var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtractCircleStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1.43 -1.43 40 40",
    id: "Subtract-Circle--Streamline-Flex",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Subtract Circle Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "subtract-circle--delete-add-circle-subtract-button-buttons-remove-mathematics-math-minus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "#ffffff",
    d: "M18.57 35.81357142857143c11.035885714285715 0 17.24357142857143 -6.207685714285715 17.24357142857143 -17.24357142857143S29.605885714285716 1.3264285714285715 18.57 1.3264285714285715 1.3264285714285715 7.534114285714286 1.3264285714285715 18.57s6.207685714285715 17.24357142857143 17.24357142857143 17.24357142857143Z",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.57 35.81357142857143c11.035885714285715 0 17.24357142857143 -6.207685714285715 17.24357142857143 -17.24357142857143S29.605885714285716 1.3264285714285715 18.57 1.3264285714285715 1.3264285714285715 7.534114285714286 1.3264285714285715 18.57s6.207685714285715 17.24357142857143 17.24357142857143 17.24357142857143Z",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1180",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M26.528571428571432 18.57 10.611428571428572 18.57",
    strokeWidth: 2.86
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtractCircleStreamlineFlex);
export default __webpack_public_path__ + "static/media/Subtract-Circle--Streamline-Flex.45b3d16ce7f0945fc90dfe47a4b1e9ac.svg";
export { ForwardRef as ReactComponent };